import './CampaignPageSkeleton.css';

const CampaignPageSkeleton: React.FC = () => {
  return (
    <div className="campaign-skeleton-container">
      {/* Campaign Info Banner Skeleton */}
      <div className="campaign-skeleton-info">
        <div className="campaign-skeleton-image">
          <div className="campaign-skeleton-image-placeholder"></div>
        </div>
        <div className="campaign-skeleton-content">
          <div className="campaign-skeleton-title">
            <div className="skeleton-title-bar"></div>
          </div>
          <div className="campaign-skeleton-skills">
            <div className="skeleton-skill-tag"></div>
            <div className="skeleton-skill-tag"></div>
            <div className="skeleton-skill-tag"></div>
          </div>
          <div className="campaign-skeleton-description">
            <div className="skeleton-text-line full"></div>
            <div className="skeleton-text-line medium"></div>
            <div className="skeleton-text-line large"></div>
            <div className="skeleton-text-line small"></div>
          </div>
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className="campaign-skeleton-main">
        {/* Stats Section Skeleton */}
        <div className="campaign-skeleton-stats">
          <div className="campaign-skeleton-stats-grid">
            {[1, 2, 3, 4].map((index) => (
              <div key={index} className="campaign-skeleton-stat-card">
                <div className="skeleton-stat-icon"></div>
                <div className="campaign-skeleton-stat-content">
                  <div className="skeleton-stat-number"></div>
                  <div className="skeleton-stat-label"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Organizer Section Skeleton */}
        <div className="campaign-skeleton-section">
          <div className="campaign-skeleton-section-title">
            <div className="skeleton-section-title"></div>
          </div>
          <div className="campaign-skeleton-organizer">
            <div className="skeleton-organizer-avatar"></div>
            <div className="campaign-skeleton-organizer-info">
              <div className="skeleton-organizer-name"></div>
              <div className="skeleton-text-line full"></div>
              <div className="skeleton-text-line medium"></div>
            </div>
          </div>
        </div>

        {/* Tasks Section Skeleton */}
        <div className="campaign-skeleton-section">
          <div className="campaign-skeleton-section-title">
            <div className="skeleton-section-title"></div>
          </div>
          <div className="campaign-skeleton-tasks">
            {[1, 2, 3].map((index) => (
              <div key={index} className="campaign-skeleton-task-card">
                <div className="skeleton-task-image"></div>
                <div className="campaign-skeleton-task-content">
                  <div className="skeleton-task-title"></div>
                  <div className="skeleton-text-line large"></div>
                  <div className="skeleton-text-line medium"></div>
                  <div className="campaign-skeleton-task-footer">
                    <div className="skeleton-task-skill"></div>
                    <div className="skeleton-task-miles"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignPageSkeleton;